<div class="contacto-page">
  <div class="col-md-10 mx-auto">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb small">
        <li class="breadcrumb-item"><a href="#">Inicio</a></li>
        <li class="breadcrumb-item active" aria-current="page">Contacto</li>
      </ol>
    </nav>

    <div class="text-center">
      <h1 class="text-primary mb-4">Conversemos</h1>
    </div>

    <div class="row justify-content-between my-6">
      <div class="col-md-4">
        <h5 class="text-secondary">
          En Orbitec gestionamos y proveemos tecnología satelital para
          incrementar la rentabilidad de tu negocio.
        </h5>

        <div class="bg-primary rounded text-white text-center p-3 mt-4 mb-3">
          <div class="mb-2">Central de emergencias: 24 Horas</div>
          <span class="h5 font-weight-bold">T: 721-0025 / C: 980951477</span>
        </div>

        <ul class="list">
          <li>
            Oficina Central: Cal. Germán Schreiber Nro. 276 Urb. Santa Ana - San
            Isidro
          </li>
          <li>
            <span class="font-weight-bold text-primary">
              Comercial y Post-venta:
            </span>
            <br />
            RPC: 944579506
          </li>
          <li>
            Escríbenos a <a href="mailto:info@orbitec.pe">info@orbitec.pe</a>
          </li>
        </ul>
      </div>

      <div class="col-md-7">
        <form
          #f="ngForm"
          [formGroup]="formContacto"
          (ngSubmit)="onSubmit()"
          novalidate
        >
          <div class="row">
            <div class="form-group col-md-6">
              <input
                type="text"
                class="form-control"
                placeholder="Nombre"
                formControlName="nombre"
              />
            </div>

            <div class="form-group col-md-6">
              <input
                type="text"
                class="form-control form-control-lg"
                placeholder="Celular"
                formControlName="celular"
              />
            </div>

            <div class="form-group col-md-12">
              <input
                type="email"
                class="form-control form-control-lg"
                placeholder="Email"
                formControlName="email"
              />
            </div>

            <div class="form-group col-md-12">
              <textarea
                class="form-control form-control-lg"
                rows="5"
                placeholder="Mensaje"
                formControlName="mensaje"
              ></textarea>
            </div>

            <div class="text-right col-12">
              <button class="btn btn-primary" type="submit">
                Enviar mensaje
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="mt-5 mb-7">
      <iframe
        src="https://maps.google.com/maps?q=Cal.%20German%20Schreiber%20276,%20San%20Isidro&t=&z=15&ie=UTF8&iwloc=&output=embed"
        width="100%"
        height="400"
        style="border: 0"
        allowfullscreen
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      >
      </iframe>
    </div>
  </div>
</div>
